import Icon, { IconProps } from '@shared/components/Icon/Icon';
import Link from 'next/link';
import React, { HTMLAttributes } from 'react';
import classNames from 'classnames';

interface FooterLogoProps {
    logoLink?: string | null;
    iconType?: IconProps['type'];
    width?: number;
    height?: number;
    className?: HTMLAttributes<HTMLAnchorElement | HTMLDivElement>['className'];
}

const FooterLogo: React.FC<FooterLogoProps> = ({
    logoLink = '/',
    iconType = 'logoWithWatermark',
    width = 201,
    height = 28,
    className,
}) => {
    const innerContent = <Icon type={iconType} width={width} height={height} />;

    const containerClasses = classNames('flex justify-start w-fit', className);

    if (!logoLink) {
        return (
            <div className={containerClasses} data-testid="footer-logo">
                {innerContent}
            </div>
        );
    }

    return (
        <Link href={logoLink} className={containerClasses} data-testid="footer-logo">
            {innerContent}
        </Link>
    );
};

export default FooterLogo;
